export default {

    log: function (message) {

        // if (__DEV__) 
        /* check env */
        console.log(message)

    }

}


// WEBPACK FOOTER //
// ./src/services/logger.js